import React from 'react'
import { useSelector } from 'react-redux';

export default function High({ symbolId, digits }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])

    return <span>{symbol?.high?.toFixed(digits || symbol.digits)}</span>;
}
